import * as _ from 'lodash';
import * as React from 'react';
import RadioInput from './RadioInput';
import './RadioGroupInput.scss';

export interface RadioOption {
  text: string;
  value: string;
}
export interface RadioGroupInputProps {
  options: RadioOption[];
  inputProps: React.InputHTMLAttributes<HTMLInputElement>;
  inline?: boolean;
}

const RadioGroupInput: React.SFC<RadioGroupInputProps> = ({ options, inline, inputProps }) => {
  // inputProps.name: Same for all radios
  // inputProps.value: Current selected value
  const radioWrapperClassName = `RadioGroupInput-itemWrapper${inline ? ' RadioGroupInput-itemInline' : ''}`;
  return (
    <fieldset>
      {_.map(options, opt => (
        <div key={opt.value} className={radioWrapperClassName}>
          <RadioInput
            {...inputProps}
            id={`${inputProps.name}-${opt.value}`}
            value={opt.value}
            checked={inputProps.value === opt.value}
          />
          <label htmlFor={`${inputProps.name}-${opt.value}`} className="RadioGroupInput-label">
            {opt.text}
          </label>
        </div>
      ))}
    </fieldset>
  );
};

export default RadioGroupInput;
